import { makeStyles, Theme } from "@material-ui/core/styles";

export const PAGINATION_HEIGHT = 64;
export default makeStyles((theme: Theme) => ({
  pagination: {
    padding: "0 16px",
    alignItems: "center",
    height: PAGINATION_HEIGHT
  },
  paginationLegend: {
    fontSize: 12,
    color: theme.palette.text.hint,
    textAlign: "left",
    lineHeight: "normal"
  },
  page: {
    border: `1px solid ${theme.palette.text.hint}`,
    color: theme.palette.text.hint,
    textTransform: "none",
    height: 28,
    minWidth: 28,
    padding: "0 4px",
    lineHeight: "normal",
    "&:hover": {
      border: `1px solid ${theme.palette.text.hint}`
    },
    "&.Mui-disabled": {
      border: "1px solid rgba(0, 0, 0, 0.15)",
      color: "rgba(0, 0, 0, 0.15)"
    },
    "&.MuiButtonGroup-grouped": {
      minWidth: 28
    }
  },
  next: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    padding: "0 8px"
  },
  previous: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    padding: "0 8px"
  },
  paginationChevron: {
    fontSize: 12
  },
  pageSelected: {
    color: theme.palette.common.white,
    border: "1px solid #000000",
    backgroundColor: "#000000",
    "&:hover": {
      border: "1px solid #000000",
      backgroundColor: "#000000"
    },
    "&.Mui-disabled": {
      border: "1px solid #000000",
      color: theme.palette.common.white
    }
  }
}));
